import { render, staticRenderFns } from "./dept.vue?vue&type=template&id=d862cf9a&scoped=true"
import script from "./dept.vue?vue&type=script&lang=js"
export * from "./dept.vue?vue&type=script&lang=js"
import style0 from "./dept.vue?vue&type=style&index=0&id=d862cf9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d862cf9a",
  null
  
)

export default component.exports